export default __webpack_public_path__ + "static/media/youtube.550cda84.svg";